import { __assign } from "tslib";
import * as React from 'react';
import { themes } from '../../ThemeOptions';
var BootStrapTable = React.lazy(function () {
    return import('../../bootstrap-table-components/components/BTTable');
});
var bootStrapTable = function (props) {
    return React.createElement(BootStrapTable, __assign({}, props));
};
export var Table = function (props) {
    var componentToDisplay = bootStrapTable(props);
    switch (props.ioTheme.uiLibrary) {
        case 'bootstrap':
            componentToDisplay = bootStrapTable(props);
    }
    return React.createElement(React.Fragment, null, componentToDisplay);
};
Table.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default Table;
//# sourceMappingURL=Table.js.map